import PropTypes from 'prop-types';

export const GoogleMapsPropTypes = {
  /**
   * Optional dragEnd listener
   * @type {Function}
   */
  dragEnd: PropTypes.func,
  /**
   * Map latitude
   * @type {Number}
   */
  latitude: PropTypes.number,
  /**
   * Map longitude
   * @type {Number}
   */
  longitude: PropTypes.number,
  /**
   * Convert marker to Google Map marker
   * @type {Function}
   */
  markerMapper: PropTypes.func,
  /**
   * List of markers to render on map
   * @type {Array}
   */
  markers: PropTypes.array,
  /**
   * Optional onClick listener
   * @type {Function}
   */
  setMarker: PropTypes.func,
  /**
   * Optional zoomChanged listener
   * @type {Function}
   */
  zoomChanged: PropTypes.func,
};
